import { Calendar } from 'lucide-react';

const navItems = [
  { id: 'accueil', label: 'Accueil' },
  { id: 'services', label: 'Services' },
  { id: 'apropos', label: 'À Propos' },
  { id: 'contact', label: 'Contact' }
];

const MobileMenu = ({ onNavigate }) => {
  return (
    <div className="mobile-menu">
      {navItems.map((item) => (
        <button
          key={item.id}
          onClick={() => onNavigate(item.id)}
          className="mobile-nav-link"
        >
          {item.label}
        </button>
      ))}
      <a 
        href={process.env.REACT_APP_BOOKING_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-primary mobile-cta"
        style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
      >
        <Calendar size={18} />
        <span>Réserver</span>
      </a>
    </div>
  );
};

export default MobileMenu;
